import React from 'react'


const Footer = () => {
    return(
        <>
            <div className='footer'>
                <p>COVID-19 Tracker created by Katy Koo</p>
            </div>
        </>
    )
}

export default Footer